<template>
    <div>
        <template v-if="loading">
            <v-col cols="12" sm="6" offset-sm="3">
                <v-card>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-progress-linear :indeterminate="true"></v-progress-linear>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-col>
        </template>
        <template v-else-if="team !== null">

            <section class="basic-info">
                <v-container>
                    <v-row>
                        <v-col cols="14" offset="1" sm="16" offset-sm="0">
                            <h2 class="section-subtitle">Základní údaje</h2>
                            <v-row>
                                <v-col cols="16" md="10" offset-md="3" sm="14" offset-sm="1">
                                    <v-row>
                                        <v-col cols="16" md="4" sm="6" class="blazon">
                                            <team-blazon-view :settings="team.blazon" />
                                        </v-col>
                                        <v-col cols="16" offset="0" md="11" offset-md="1" sm="9" offset-sm="1">
                                            <v-form>
                                                <v-text-field
                                                    dark
                                                    :value="team.name"
                                                    label="Název teamu"
                                                    :readonly="true"
                                                />
                                                <v-text-field
                                                    dark
                                                    :value="team.owner.nickname"
                                                    label="Majitel týmu"
                                                    :readonly="true"
                                                />
                                            </v-form>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-container>
            </section>

            <section class="team-members">

                <team-members
                    :players="team.players"
                    :can-fire-member="false"
                />

            </section>

        </template>
    </div>
</template>

<script>
    import { GET_TEAM_DETAIL_REQUEST } from '../store/actions/team'
    import TeamMembers from '../components/Team/TeamMembers';
    import TeamBlazonView from '../components/TeamBlazon/TeamBlazonView.vue';

    export default {
        components: {
            TeamBlazonView,
            TeamMembers,
        },
        props: {
            id: {
                type: String,
                required: true,
            },
        },
        data () {
            return {
                team: null,
                loading: false,
            };
        },
        async mounted () {
            try {
                this.loading = true;
                this.team = await this.$store.dispatch('team/' + GET_TEAM_DETAIL_REQUEST, { id: this.id });
            } catch (e) {
                const message = e.response.data.message || 'Došlo k chybě při načítání týmu. Zkuste to později.';
                this.$toast.error(message);
            } finally {
                this.loading = false;
            }
        },
    }
</script>
